import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";

const DitlSectionHeader = ({ icon: Icon, iconClassName = "", label }) => (
  <div className="tw-flex tw-items-center tw-gap-[4px] tw-px-[8px] tw-py-[4px]">
    <Icon className={`tw-w-[12px] tw-h-[12px] ${iconClassName}`} />
    <Typography variant="subtitle-s" component="span" className="!tw-text-gray-50">
      {label}
    </Typography>
  </div>
);

DitlSectionHeader.propTypes = {
  icon: PropTypes.elementType.isRequired,
  iconClassName: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default DitlSectionHeader;
